import axios from "axios";
import { storage } from "stores";
import { SetterOrUpdater } from "recoil";
import { _goToRoot } from "routers/helper";
import { colors } from "assets/constants";

type ParamsT = {
  auth: AuthDataT;
  setAuth: SetterOrUpdater<AuthDataT>;
};

export const onAuthRes = (params: ParamsT) => {
  if (params?.auth?.company?.status === "disable") {
    delete axios.defaults.headers.common.Authorization;
    params.setAuth({ company: { color: colors.theme } });
    storage.set(null);
  } else {
    params.setAuth(params?.auth);
    storage.set(params?.auth);
  }
};

export const onVerifyCodeResponse = (params: ParamsT) => {
  if (params?.auth?.company?.status === "disable") {
    delete axios.defaults.headers.common.Authorization;
    params.setAuth({ company: { color: colors.theme } });
    storage.set(null);
  } else {
    axios.defaults.headers.common.Authorization =
      "Bearer " + params?.auth?.token;
    params.setAuth(params?.auth);
    storage.set(params?.auth);
  }
};

export const onLogoutResponse = (props: {
  setAuth: SetterOrUpdater<AuthDataT>;
}) => {
  delete axios.defaults.headers.common.Authorization;
  props.setAuth({ company: { color: colors.theme } });
  storage.set(null);
};

export const loginToCtoAccountResponse = (props: {
  auth: AuthDataT;
  setAuth: SetterOrUpdater<AuthDataT>;
}) => {
  // console.log("auth", props.auth);
  // axios.defaults.headers.common.Authorization = "Bearer " + props.auth?.token;
  // props.setAuth(props.auth);
  // storage.set(props.auth);
  // _goToRoot();
};
